<template>
  <div class="orm-slider" v-if="images.length > 1">
    <span class="orm_icon_fullscreen text-center" @click="toggler = !toggler"
      ><i class="fas fa-expand-arrows-alt"></i
    ></span>
    <div class="orm-row">
      <div
        class="orm-mb-4"
        :class="[
          index === 0
            ? 'orm-col-xs-12 orm-col-sm-12'
            : 'orm-col-xs-6 orm-col-sm-6',
        ]"
        v-for="(item, index) in images"
        :key="item"
      >
        <div v-if="index === 0">
          <img
            :src="encodeURI(item.image)"
            alt=""
            @click="toggler = !toggler"
            class="orm-w100 img-hover"
          />
        </div>
        <div v-if="index > 0">
          <img :src="encodeURI(item.image)" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="orm-slider__inner">
    <span class="orm_icon_fullscreen text-center" @click="toggler = !toggler"
      ><i class="fas fa-expand-arrows-alt"></i
    ></span>

    <img
      :src="encodeURI(images[0].image)"
      alt=""
      @click="toggler = !toggler"
      class="img-hover"
    />
  </div>
  <FsLightbox :toggler="toggler" :sources="fullimages()" />
</template>
<script>
import FsLightbox from "fslightbox-vue/v3";

export default {
  name: "Slider",
  props: {
    images: Array,
    ratio: {
      type: String,
      required: false,
      default: "4/3",
    },
    controlls: {
      type: Boolean,
      required: false,
      default: true,
    },
    dots: {
      type: Boolean,
      required: false,
      default: true,
    },
    arrows: {
      type: Boolean,
      required: false,
      default: false,
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true,
    },
    intervall: {
      type: Number,
      required: false,
      default: 7000,
    },
    lightbox: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: { FsLightbox },
  data() {
    return {
      timer: null,
      currentIndex: 0,
      items: Number,
      toggler: false,
      size: 900,
    };
  },
  mounted() {
    this.items = this.images.length - 1;
    if (this.images.length > 1 && this.autoplay) this.startSlide();

    this.$el.addEventListener("touchstart", this.startTouch, false);
    this.$el.addEventListener("touchmove", this.moveTouch, false);
    this.$el.addEventListener("mousedown", this.startTouch, false);
    this.$el.addEventListener("mouseup", this.moveTouch, false);
  },

  unmounted() {
    this.$el.removeEventListener("touchstart", this.startTouch, false);
    this.$el.removeEventListener("touchmove", this.moveTouch, false);
    this.$el.removeEventListener("mousedown", this.startTouch, false);
    this.$el.removeEventListener("mouseup", this.moveTouch, false);
  },

  methods: {
    fullimages() {
      const imageToArray = this.images.map((obj) => obj.image);
      const fullImages = [];
      imageToArray.forEach((element) => {
        fullImages.push(element.replace(/\/300\//g, "/" + this.size + "/"));
      });
      return fullImages;
    },
    startSlide() {
      this.timer = setInterval(this.next, this.intervall);
    },

    next() {
      this.currentIndex += 1;
      if (this.currentIndex > this.items) this.currentIndex = 0;
    },
    prev() {
      this.currentIndex -= 1;
      if (this.currentIndex < 0) this.currentIndex = this.items;
    },
    showItem(index) {
      this.currentIndex = index;
      if (this.images.length > 1 && this.autoplay) {
        clearInterval(this.timer);
        this.timer = setInterval(this.next, this.intervall);
      }
    },
    calcRatio(ratio) {
      const splitRatio = ratio.split("/");
      const calc = (splitRatio[1] / splitRatio[0]) * 100;
      return calc.toFixed(2);
    },
    startTouch(e) {
      if (e.type == "mousedown") {
        this.initialX = e.clientX;
        this.initialY = e.clientY;
      } else {
        this.initialX = e.touches[0].clientX;
        this.initialY = e.touches[0].clientY;
      }
    },

    moveTouch(e) {
      if (this.initialX === null) {
        return;
      }

      if (this.initialY === null) {
        return;
      }
      let currentX = 0;
      let currentY = 0;
      if (e.type == "mouseup") {
        currentX = e.clientX;
        currentY = e.clientY;
      } else {
        currentX = e.touches[0].clientX;
        currentY = e.touches[0].clientY;
      }

      const diffX = this.initialX - currentX;
      const diffY = this.initialY - currentY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        // sliding horizontally
        if (diffX > 0) {
          this.next();
        } else {
          this.prev();
        }
      } else {
        // sliding vertically
        if (diffY > 0) {
          // swiped up
          // console.log("swiped up");
        } else {
          // swiped down
          // console.log("swiped down");
        }
      }

      this.initialX = null;
      this.initialY = null;

      e.preventDefault();
    },
    openLightbox() {
      console.log(this.lightbox);
    },
  },

  computed: {
    currentImg: function() {
      return encodeURI(
        this.images[Math.abs(this.currentIndex) % this.images.length].image
      );
    },
  },
};
</script>
